import * as Draft from 'draft-js';

import { alignBlockStyleFn } from '../Toolbar/Items/Align/Align';

export const useBlockStyleFn = () => {
  const blockStyleFn = (contentBlock: Draft.ContentBlock): string => {
    // Align blocks
    const alignStyle = alignBlockStyleFn(contentBlock);
    if (alignStyle) return alignStyle;

    return '';
  };

  return blockStyleFn;
};
